<template>
  <div class="administrationcities-container">
    <div class="filter-card">
      <div class="filter-row">
        <div class="filter-dropdowns">
          <LazyDropdown
            endpoint="/places/countries"
            v-model="selectedCountry"
            placeholder="Paese"
            style="width: 220px;"
          />
          <LazyDropdown
            v-if="selectedCountry"
            :endpoint="`/places/states?country_id=${selectedCountry}`"
            v-model="selectedState"
            placeholder="Regione"
            style="width: 220px;"
          />
          <LazyDropdown
            v-if="selectedState"
            :endpoint="`/places/districts?state_id=${selectedState}`"
            v-model="selectedDistrict"
            placeholder="Provincia"
            style="width: 220px;"
          />
        </div>
        <vs-button size="large" @click="showMassiveCityImportDialog = true">
          Importa Città da Excel
        </vs-button>
      </div>
    </div>
    <vs-table v-if="selectedDistrict" style="height: 80vh; width: 100%; margin-top: 20px;">
      <template #thead>
        <vs-tr>
          <vs-th>City</vs-th>
          <vs-th>Actions</vs-th>
        </vs-tr>
      </template>
      <template #tbody>
        <vs-tr v-for="city in cities" :key="city.id">
          <vs-td>{{ city.name }}</vs-td>
          <vs-td>
            <template v-if="deletingCityId === city.id">
              <vs-button
                size="small"
                danger
                @click="deleteCity(city.id)"
                style="margin-right: 8px;"
              >
                Conferma
              </vs-button>
              <vs-button
                size="small"
                @click="deletingCityId = null"
              >
                Annulla
              </vs-button>
            </template>
            <template v-else>
              <vs-button
                size="small"
                danger
                icon
                @click="deletingCityId = city.id"
                title="Delete"
              >
                <i class="bx bx-trash"></i>
              </vs-button>
            </template>
          </vs-td>
        </vs-tr>
      </template>
      <template #footer>
        <vs-row justify="center" align="center">
          <vs-button :disabled="result == null || result.before == null" @click="previousPage">
            <img src="../../assets/icons/previous_page.png" />
          </vs-button>
          <vs-button :disabled="result == null || result.after == null" @click="nextPage">
            <img src="../../assets/icons/next_page.png" />
          </vs-button>
        </vs-row>
      </template>
    </vs-table>
    <MassiveCityImport
      :show="showMassiveCityImportDialog"
      :onClose="() => { showMassiveCityImportDialog = false }"
    />
  </div>
</template>

<script>
import { apiCall } from '../../utils/ApiMiddleware';
import LazyDropdown from '../../components/LazyDropdown.vue';
import MassiveCityImport from '../../components/elements/MassiveCityImport.vue';

export default {
  name: 'Cities',
  components: { LazyDropdown, MassiveCityImport },
  data() {
    return {
      selectedCountry: null,
      selectedState: null,
      selectedDistrict: null,
      cities: [],
      result: null,
      showMassiveCityImportDialog: false,
      deletingCityId: null,
    };
  },
  watch: {
    selectedCountry() {
      this.selectedState = null;
      this.selectedDistrict = null;
      this.cities = [];
      this.result = null;
    },
    selectedState() {
      this.selectedDistrict = null;
      this.cities = [];
      this.result = null;
    },
    selectedDistrict(newVal) {
      this.cities = [];
      this.result = null;
      if (newVal) {
        this.fetchCities();
      }
    },
  },
  methods: {
    async fetchCities(pagination = {}) {
      if (!this.selectedDistrict) return;
      const params = { district_id: this.selectedDistrict, ...pagination };
      const loading = this.$vs.loading();
      const response = await apiCall('GET', '/places/cities', params);
      loading.close();
      if (response.status === 200 && Array.isArray(response.data.data)) {
        this.cities = response.data.data;
        this.result = response.data;
      } else {
        this.cities = [];
        this.result = null;
      }
    },
    previousPage() {
      if (this.result && this.result.before) {
        this.fetchCities({ before: this.result.before });
      }
    },
    nextPage() {
      if (this.result && this.result.after) {
        this.fetchCities({ after: this.result.after });
      }
    },
    // confirmDelete removed, now handled inline
    async deleteCity(cityId) {
      const loading = this.$vs.loading();
      const response = await apiCall('DELETE', `/places/cities/${cityId}`);
      loading.close();
      if (response.status === 200) {
        this.$vs.notification({
          title: 'Success',
          text: 'City deleted successfully.',
          color: 'success',
          position: 'top-right',
        });
        this.fetchCities();
      } else {
        this.$vs.notification({
          title: 'Error',
          text: 'Failed to delete city.',
          color: 'danger',
          position: 'top-right',
        });
      }
    },
  },
};
</script>

<style scoped>
.administrationcities-container {
  padding-left: 70px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
}
.filter-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 24px 24px 32px 24px;
  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.filter-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
.filter-dropdowns {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
</style>
